// Hides the product's primary media (product.media.first) from the PDP gallery
// when Easy Variant Images is rebuilding the carousel. EVI clones .product-gallery__media
// items from its own product JSON, bypassing Liquid-level hidden attributes — so we
// observe its DOM and re-apply the hide whenever it rebuilds.
//
// Gates:
//   - <product-gallery data-primary-media-id> must be present (Liquid only renders this
//     when product.variants.size > 1 and product.media.size > 1).
//   - EVI must be active on the page (window.spice_evi_productJSON exists).
//   - Never hide if it would leave zero visible media.
(function () {
  'use strict';

  function init() {
    var gallery = document.querySelector('product-gallery[data-primary-media-id]');
    if (!gallery) return;
    if (!window.spice_evi_productJSON) return;

    var primaryId = gallery.getAttribute('data-primary-media-id');
    if (!primaryId) return;

    function hidePrimary() {
      var allMedia = gallery.querySelectorAll('.product-gallery__media');
      var visible = [];
      var primaryMatches = [];
      allMedia.forEach(function (el) {
        if (el.hasAttribute('hidden')) return;
        if (el.getAttribute('data-media-id') === primaryId) {
          primaryMatches.push(el);
        } else {
          visible.push(el);
        }
      });
      if (primaryMatches.length === 0) return;
      if (visible.length === 0) return; // guard: don't blank the gallery
      primaryMatches.forEach(function (el) { el.setAttribute('hidden', ''); });

      // Mirror to thumbnails and page-dots which use the same data-media-id pattern is absent,
      // but they iterate product.media in order. Their buttons match by position, not id.
      // Hide any thumbnail/dot whose <img> src matches the primary media's src.
      var primaryImg = primaryMatches[0].querySelector('img');
      if (!primaryImg) return;
      var primarySrc = primaryImg.getAttribute('src');
      if (!primarySrc) return;
      var primarySrcKey = primarySrc.split('?')[0];
      gallery.querySelectorAll('.product-gallery__thumbnail img, page-dots button img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        if (src.split('?')[0] === primarySrcKey) {
          var btn = img.closest('button');
          if (btn && !btn.hasAttribute('hidden')) btn.setAttribute('hidden', '');
        }
      });
    }

    hidePrimary();

    var debounce;
    var observer = new MutationObserver(function () {
      if (debounce) cancelAnimationFrame(debounce);
      debounce = requestAnimationFrame(hidePrimary);
    });
    observer.observe(gallery, { childList: true, subtree: true });

    // Re-run on variant change in case EVI rebuilds asynchronously.
    document.addEventListener('variant:change', hidePrimary);
    document.addEventListener('variant:changed', hidePrimary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
